import React from 'react';
import InputField from 'customField/InputField';
import { Field, FastField } from 'formik';

/**
 *
 * @param {Object} props
 * @param {"text" | "password" | "textarea" | "submit" | "reset" | "radio" | "checkbox" | "file" | "hidden" | "image" | "date" | "color"} props.type
 * @param {string} props.name
 * @param {any} props.label
 * @param {string} props.placeholder
 * @param {string} props.classNameContainer - Class name of div that wrapping label, input and error message
 * @param {string} props.className - Class name of input
 * @param {boolean} props.autoFocus
 * @param {boolean} props.isShowHidePassword
 * @param {boolean} props.isFastField
 * @param {boolean} props.required
 * @param {boolean} props.disabled
 * @param {any} props.addOnText
 * @param {"prepend" | "append"} props.addOnType - Default: append
 * @param {Object} props.style
 * @param {(event) => void} props.afterOnChange
 * @returns
 */
const Input = (props) => {
  const FieldWrapper = props.isFastField ? FastField : Field;
  return <FieldWrapper component={InputField} {...props} />;
};

export default Input;
